WW.masonry = function($) {
    'use strict';
    function init() {
        $('.js-masonry').masonry({
            // options...
            itemSelector: '.js-masonry__item'
        });
    }
    setTimeout(init, 500);
    window.onload = init;

    // Make masonry work in tabs as well
    $('.js-tabs').on('click', '.js-tab-toggle', init);
    return this;
};